/*------------------------------------------------
// File Name:PDM_BodyCheck_FenLei.js
// File Description:PDM_BodyCheck_FenLei API方法js接口
// Author:zxl
// Create Time:2023/04/03 18:29:43
//------------------------------------------------*/
import { axios } from '@/utils/request'

const api = {
   _bodycheckFenlei: "/PDM_BodyCheck_FenLei"
}

export default api


//-------------------创建对象-------------------
export function CreatePDM_BodyCheck_FenLeiEntity(parameter) {
    return axios({
        url: api._bodycheckFenlei + "/CreatePDM_BodyCheck_FenLeiEntity",
        method: 'post',
        data: parameter
    })
}

//-------------------获取列表-------------------
export function GetPDM_BodyCheck_FenLeiList(parameter) {
    return axios({
        url: api._bodycheckFenlei + "/GetPDM_BodyCheck_FenLeiList",
        method: 'post',
        data: parameter
    })
}

//-------------------分页获取列表---------------
export function GetPDM_BodyCheck_FenLeiListByPage(parameter) {
    return axios({
        url: api._bodycheckFenlei + "/GetPDM_BodyCheck_FenLeiListByPage",
        method: 'post',
        data: parameter
    })
}

//-------------------获取对象---------------
export function GetPDM_BodyCheck_FenLeiEntity(parameter) {
    return axios({
        url: api._bodycheckFenlei + "/GetPDM_BodyCheck_FenLeiEntity",
        method: 'post',
        data: parameter
    })
}


//-------------------保存对象---------------
export function UpdatePDM_BodyCheck_FenLeiEntity(parameter) {
    return axios({
        url: api._bodycheckFenlei+ "/UpdatePDM_BodyCheck_FenLeiEntity",
        method: 'post',
        data: parameter
    })
}

//-------------------删掉对象---------------
export function DeletePDM_BodyCheck_FenLeiEntity(parameter) {
    return axios({
        url: api._bodycheckFenlei + "/DeletePDM_BodyCheck_FenLeiEntity",
        method: 'post',
        data: parameter
    })
}

//-------------------启用/禁用---------------
export function UpateIsDel(parameter) {
    return axios({
        url: api._bodycheckFenlei + "/UpateIsDel",
        method: 'post',
        data: parameter
    })
}
